import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, LoaderService } from '~services';

@Component({
  selector: 'app-auth-login-view',
  template: ``,
  standalone: false,
})
export class AuthLoginViewComponent implements OnInit, OnDestroy {
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private loaderService: LoaderService,
  ) {}

  async ngOnDestroy(): Promise<void> {
    this.loaderService.hide();
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.show();
    await this.authService.handleLogin(this.returnTo);
  }

  private get returnTo() {
    return this.activatedRoute.snapshot.queryParams.returnTo;
  }
}
